import { CLASSES_BOOK } from '../../../api/endpoints';
import request from '../../../api/request';
import {
  PaginationQueryDto,
  PaginationRequestType,
} from '../../../types/paginationRequestType';
import {
  ClassesBookClassResponse,
  ClassesBookForm,
  ClassesBookItem,
  LessonActivity,
  SearchParams,
} from '../types';

export const getClassesBookForm = () =>
  request<ClassesBookForm>(CLASSES_BOOK.FORM);

export const getSectionClasses = (sectionId: string | number) =>
  request<ClassesBookClassResponse>(
    CLASSES_BOOK.GET_SECTION_CLASSES(sectionId),
  );

export const createSectionClassActivity = (
  sectionId: string | number,
  classId: string | number,
  payload: Pick<
    LessonActivity,
    'courseLearningUnitId' | 'contents' | 'criteria' | 'activities'
  >,
) =>
  request<void>(CLASSES_BOOK.CREATE_SECTION_CLASS_ID(sectionId, classId), {
    data: payload,
    method: 'POST',
  });

export const updateSectionClassActivity = (
  sectionId: string | number,
  activityId: string | number,
  payload: Pick<
    LessonActivity,
    'courseLearningUnitId' | 'contents' | 'criteria' | 'activities'
  >,
) =>
  request<void>(
    CLASSES_BOOK.UPDATE_SECTION_CLASS_ACTIVITY_ID(sectionId, activityId),
    {
      data: payload,
      method: 'PUT',
    },
  );

export const removeSectionClassActivity = (
  sectionId: string | number,
  activityId: string | number,
) =>
  request<void>(
    CLASSES_BOOK.UPDATE_SECTION_CLASS_ACTIVITY_ID(sectionId, activityId),
    {
      method: 'DELETE',
    },
  );

export const getPaginatedClassesBook = (
  params: PaginationQueryDto<SearchParams<string>>,
) =>
  request<PaginationRequestType<ClassesBookItem<undefined>>>(
    CLASSES_BOOK.GET_PAGINATED_ITEMS,
    { params },
  );

export async function downloadReport({
  sectionId,
}: {
  sectionId: string;
}): Promise<any> {
  const res = await request(CLASSES_BOOK.DOWNLOAD_REPORT(sectionId), {
    method: 'GET',
    responseType: 'blob',
  });
  return res;
}

export async function downloadExcel({
  sectionId,
}: {
  sectionId: string;
}): Promise<any> {
  const res = await request(CLASSES_BOOK.DOWNLOAD_EXCEL(sectionId), {
    method: 'GET',
    responseType: 'blob',
  });
  return res;
}
